import {
  gtagEvent,
  lineItemToGa4,
  trackViewItemFromProduct,
} from "helpers/ga4Ecommerce";

const ADD_TO_CART_TYPES = new Set([
  "cart/addToCart",
  "cart/addDomainToCart",
  "cart/addDomainTransferToCart",
  "cart/addWhoisToCart",
  "cart/addPremiumToCart",
]);

function fireAddToCartFromPayload(payload) {
  if (!payload || typeof payload !== "object") return;
  const item = lineItemToGa4(payload);
  gtagEvent("add_to_cart", {
    currency: "IDR",
    value: item.price,
    items: [{ ...item, quantity: 1 }],
  });
}

/**
 * Middleware Redux: view_item (fetch produk by PID) + add_to_cart (aksi cart terpilih).
 */
export const ga4EcommerceMiddleware = (store) => (next) => (action) => {
  if (action.type === "products/getFromPID/fulfilled" || action.type === "products/getProductPromo/fulfilled") {
    const product = action.payload?.products?.product?.[0];
    const result = next(action);
    if (product) {
      trackViewItemFromProduct(product);
    }
    return result;
  }

  if (ADD_TO_CART_TYPES.has(action.type)) {
    const prevLen = store.getState().cart?.productsList?.length ?? 0;
    const result = next(action);
    const nextLen = store.getState().cart?.productsList?.length ?? 0;
    if (nextLen > prevLen) {
      fireAddToCartFromPayload(action.payload);
    }
    return result;
  }

  return next(action);
};
